<template>
  <div data-component="base-settings-menu-group">
    <div class="title">
      {{ group.title }}
    </div>

    <or-menu-item
      v-for="item in group.items"
      :key="item.id"
      :class="{ 'is-active': isItemActive(item) }"
      :icon="item.icon"
      :selected="isItemActive(item)"
      data-nav="settings-menu-tab"
      @click="$emit('item-click', item.id)"
    >
      {{ item.label }}
    </or-menu-item>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue-demi';
import { OrMenuItemV3 as OrMenuItem } from '@onereach/ui-components-25';
import { MenuItem, MenuItemGroup } from '../types';

export default defineComponent({
  name: 'BaseSettingsMenuGroup',
  components: { OrMenuItem },
  props: {
    group: {
      type: Object as PropType<MenuItemGroup>,
      default: () => ({}),
    },
    activeItemId: {
      type: String,
      default: '',
    },
  },
  emits: ['item-click'],
  methods: {
    isItemActive(item: MenuItem) {
      return item.id === this.activeItemId;
    },
  },
});
</script>

<style lang="scss" scoped>
@use '@/styles' as *;

[data-component='base-settings-menu-group'] {
  display: flex;
  flex-direction: column;

  .title {
    @include text-overflow;
    padding: var(--s-3);
    color: var(--or-c-outline);
    font-size: var(--fs-0);
  }

  .or-menu-item-v3.is-active {
    background: var(--or-c-primary-opacity-0-08);
  }
}
</style>
